export default {
  API: 'API',
  SERVICES: {
    BRAINTREE: 'BRAINTREE',
    FRONTEND: 'FRONTEND',
    GREENHOUSE: 'GREENHOUSE',
    KUSTOMER: 'KUSTOMER',
    SLI: 'SLI',
    SOLIDUS: 'SOLIDUS',
    STRAPI: 'STRAPI'
  }
};
